import { ReactNode } from 'react';
import { BackButton } from '@/components/ui/back-button';

interface PageHeaderProps {
  title: string;
  children?: ReactNode;
  className?: string;
  backHref?: string;
  backTooltip?: string;
}

export function PageHeader({ title, children, className = '', backHref, backTooltip }: PageHeaderProps) {
  return (
    <section className={`pl-page-inset pr-5 ${className}`}>
      {/* min-h matches an input row (h-12) so title-only headers centre on the sidebar's logo row too */}
      <div className="flex items-center justify-between min-h-12">
        <div className="flex items-center gap-3">
          {backHref && <BackButton href={backHref} tooltip={backTooltip} />}
          <h1 className="text-lg font-medium">{title}</h1>
        </div>
        {children && (
          <div className="flex items-center gap-3">
            {children}
          </div>
        )}
      </div>
    </section>
  );
}

